import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { profileSelectors } from '../../../../store/selectors/profile';
import { editUserInfoThunk } from '../../../../store/thunks/profile';
import { authSelectors } from '../../../../store/selectors/auth';
import { useNavigate } from 'react-router-dom';
import actions from '../../../../store/actions';

import Field from '../../../../common/Fields/Field';
import LoadingBtn from '../../../LoadingBtn/LoadingBtn';
import ErrorMessage from '../../../../common/Errors/ErrorMessage';

const InstagramForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profile = useSelector(profileSelectors);
  const auth = useSelector(authSelectors);
  const token = auth.token;
  const user = profile.user;
  const errors = profile.errors;
  const load = profile.load;
  const edit = profile.edit;
  const confirmInfo = profile.confirmInfo;

  const [nickname, setNickname] = useState('');
  const [fieldConfirmed, setFieldConfirmed] = useState('');

  useEffect(() => {
    if(edit) {
      navigate('/profile');
      dispatch(actions.profile.editUserInfo(false));
      dispatch(actions.profile.profileError({}));
    }
  }, [edit]);

  useEffect(() => {
    if(Object.keys(user).length > 0 && user.nickname) {
      setNickname(user.nickname);
    }
  }, [user]);

  useEffect(() => {
    if(confirmInfo.length > 0) {
      setFieldConfirmed(confirmInfo.find(field => field.field === 'nickname'));
    }
  }, [confirmInfo]);

  useEffect(() => {
    if(fieldConfirmed) {
      setNickname(fieldConfirmed.value_to);
    }
  }, [fieldConfirmed]);

  const handleEdit = (e) => {
    e.preventDefault();
    dispatch(editUserInfoThunk({value: nickname, field: 'nickname', token}));
  };

  return (
    <form className='form profile-form'>

      <Field 
        name="nickname" 
        type="text"
        value={nickname} 
        labelText="Нікнейм Instagram" 
        onChange={(e) => setNickname(e.target.value.trim())} 
        formClass="required"
        required
      />
      {errors?.value &&  errors.value.map(err => <ErrorMessage key={err} errorText={err} />)}

      <div className="profile__btns">
        <LoadingBtn load={load} btnText='Змінити' onClick={handleEdit} />
      </div>
    </form>
  ); 
};

export default InstagramForm;